module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infobit pointable",
    style: (_vm.css),
    attrs: {
      "tabindex": _vm.tabIndex,
      "title": _vm.typeDef.name + ' ID: ' + _vm.infobit.id
    },
    on: {
      "click": _vm.select
    }
  }, [_c('div', {
    class: ['icon', 'fa', 'fa-fw', _vm.iconClass],
    style: (_vm.css)
  }), _vm._v(" "), _c('div', {
    class: ['title', {
      highlight: _vm.isSelected
    }]
  }, [_vm._v(_vm._s(_vm.infobit.title))]), _vm._v(" "), _c('div', {
    staticClass: "button-panel"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f0a6064c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/infobit.vue
// module id = 151
// module chunks = 0